<script>
import { mapActions, mapGetters } from "vuex";
import moment from "moment";
import Global from "@/constants/Global.js";
import Auth from "@/modules/Auth";
import userStyle from "@/enum/user-style";
export default {
  methods: {
    ...mapActions([
      "fetchUserProfile",
      "postUserItemMessage",
      "postGarageUserMessage",
      "postUserGroupMessage",
      "fetchProfileItems",
      "fetchProfileGroups",
      "passwordForgot",
      "changePassword",
      "forgotUsername",
      "resetResponse",
      "cancelJoinRequest",
      "acceptMember",
      "fetchMyJoinRequests",
      "fetchMyInvitations",
      "fetchModeratorInvitationsData",
      "acceptJoinInvitation",
      "acceptModeratorInvitation",
      "declineJoinInvitation",
      "rejectModeratorInvitation",
      "uploadHeaderPhoto",
      "emailUpdate",
      "searchAPI",
      "fetchMyPoints",
      "fetchMyPointSum",
      "fetchMyEarnedPoints",
      "fetchMySpentPoints",
      "checkSuperuser",
      "updateProfilePhoto",
      "removeProfilePhoto",
      "startSession",
      "fetchUserMessages",
      "getMyGroups",
      "fetchSystemNotifications",
      "endSession",
      "refreshUser",
      "removeFromFeed",
      "fetchGroupsYouMayLike",
      "fetchFeed",
      "invitationEmail",
      "checkSessionDueDate",
      "resendActivation",
      "prepareUpdatedUser",
      "updateUser",
      "getUserLocation",
      "saveUserLocation",
      "commitScrollStatus",
      "getDontShowModal",
      "saveDontShowAgain",
      "setIsFirstLogin",
    ]),
    getOthersFirstLetter(user) {
      if (user && user.firstName) {
        return user.firstName.slice(0, 1).toUpperCase();
      } else if (user && user.username) {
        return user.username.slice(0, 1).toUpperCase();
      }

      return "";
    },
    getOthersColor(user) {
      if (!user) return "";
      if (user.userStyleId) {
        const styleId = user.userStyleId;
        switch (styleId) {
          case userStyle.CYAN_USER:
            return "cyan-user";
          case userStyle.DARK_BLUE_USER:
            return "dark-blue-user";
          case userStyle.PURPLE_USER:
            return "purple-user";
          case userStyle.GREEN_USER:
            return "green-user";
          case userStyle.GRAY_USER:
            return "gray-user";
          case userStyle.ORANGE_USER:
            return "orange-user";
          case userStyle.YELLOW_USER:
            return "yellow-user";
          default:
            return "dark-blue-user";
        }
      } else {
        return "dark-blue-user";
      }
    },
    getUserImagePath(user) {
      if (user && user.id)
        return `${Global.getServerDomain()}/images/user/${user.id}.jpg`;
      return `${Global.getServerDomain()}/images/user/2.jpg`;
    },
    getUserName(user) {
      if (user && user.firstName) {
        return `${user.firstName}`;
      } else if (user && user.username) {
        return `${user.username}`;
      }
      return "Username undefined";
    },
    getRequestDescription(request) {
      return `${request.group.description}`;
    },
    getRequestTitle(request) {
      return `${request.group.name}`;
    },
    getUserHeaderProfileImg(id) {
      return `${Global.getServerDomain()}/images/user/header/${id}`;
    },
    deauth() {
      Auth.deauthenticateUser();
      localStorage.removeItem("user_id");
      this.endSession();
    },
    async sendUserGroupMessageForModerator(receiver, sender, message, groupId) {
      const payload = {
        receiver,
        sender,
        msg: message,
      }
      await this.postUserGroupMessage({
        message: payload,
        partner: payload.receiver.id,
        group: groupId,
        postMsg: payload.msg,
        newChat: true,
      });
    }
  },
  computed: {
    ...mapGetters({
      user: "getUserProfile",
      profileTimeline: "getProfileTimeline",
      response: "getRequestResponse",
      loggedUser: "getUser",
      headerPhoto: "getHeaderUserPhoto",
      getMyJoinRequests: "getMyJoinRequests",
      searchResult: "getSearchResult",
      userItems: "getProfileItems",
      userGroups: "getProfileGroups",
      myPoints: "getMyPoints",
      myPointsum: "getMyPointSum",
      myEarnedPoints: "getMyEarnedPointSum",
      mySpentPoints: "getMySpentPointSum",
      isUserAuthenticated: "isUserAuthenticated",
      userMsgs: "getUserMessages",
      pageBottom: "getScrollBottom",
      isFirstLogin: "getIsFirstLogin",
    }),
    getUserFirstLetter() {
      if (this.loggedUser && this.loggedUser.firstName) {
        return this.loggedUser.firstName.slice(0, 1).toUpperCase();
      } else if (this.loggedUser && this.loggedUser.username) {
        return this.loggedUser.username.slice(0, 1).toUpperCase();
      }

      return "";
    },
    getUserColor() {
      const user = this.loggedUser;
      if (!user) return "";
      if (user.userStyleId) {
        const styleId = user.userStyleId;
        switch (styleId) {
          case userStyle.CYAN_USER:
            return "cyan-user";
          case userStyle.DARK_BLUE_USER:
            return "dark-blue-user";
          case userStyle.PURPLE_USER:
            return "purple-user";
          case userStyle.GREEN_USER:
            return "green-user";
          case userStyle.GRAY_USER:
            return "gray-user";
          case userStyle.ORANGE_USER:
            return "orange-user";
          case userStyle.YELLOW_USER:
            return "yellow-user";
          default:
            return "dark-blue-user";
        }
      } else {
        return "dark-blue-user";
      }
    },
  },
  filters: {
    date(date) {
      if (!date) return "";
      const dt = new Date(date);
      const f = (d) => (d < 10 ? "0" + d : d);
      return (
        f(dt.getMonth() + 1) + "/" + f(dt.getDate()) + "/" + dt.getFullYear()
      );
    },
    relativeDate(date) {
      if (!date) return "";

      const dt = moment(date);
      moment.updateLocale("en", {
        relativeTime: {
          future: "in %s",
          past: "%s ago",
          s: "a few seconds",
          ss: "%d seconds",
          m: "a minute",
          mm: "%d minutes",
          h: "an hour",
          hh: "%d hours",
          d: "a day",
          dd: "%d days",
          w: "a week",
          ww: "%d weeks",
          M: "a month",
          MM: "%d months",
          y: "a year",
          yy: "%d years",
        },
      });

      return dt.fromNow();
    },
  },
};
</script>
